<template>
  <div>
    <tooltip label="View" type="default" placement="right">
      <a class="button button-table is-small" @click="url(data.id)">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
    <tooltip label="Check Payment" type="default" placement="right">
      <a class="button button-table is-small" @click="checkService(data.id)">
        <i class="fa fa-arrow-right"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      url (service) {
        window.open('#/services/service/' + service)
      },
      view () {
        this.$router.push({name: 'Service', params: {id: this.data.id}})
      },
      refresh () {
        let service = ''
        if (parseInt(this.data.integration) === 1) {
          service = this.data.service_id
        } else {
          service = this.data.api_service_id
        }
        this.$http.post(this.$store.state.config.apiURL + '/services/refresh', {booking_id: this.data.booking_id}).then((response) => {
          this.message('success', 'Success', 'The service ' + service + ' was successfully refresh')
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      checkService (id) {
        if (window.confirm('Are you sure you want check this card payment?')) {
          this.error = ''
          this.$http.post(this.$store.state.config.apiURL + '/card_payment/check', {id: id}).then((response) => {
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.message
            } else {
              this.close(false, 'ok')
            }
            this.inProgress = false
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// CardServicesTableButtons.vue?7bd68745